module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-3.365fd450.png";